export default {
  getTipAlternative: (state) => state.tipAlternative,
};
